import { LoaderCentered } from '@modules/components';
import { lazy, Suspense } from 'react';
import { useMfAnalyticsConfig } from './useMfAnalyticsConfig';

const RemoteAnalytics = lazy(() => import('@modules/remotes/analytics'));

function AdmModuleAnalytics() {
  const config = useMfAnalyticsConfig();

  return (
    <Suspense fallback={<LoaderCentered />}>
      <div style={{ display: 'contents' }} data-testid="adm.analytics.wrapper">
        <RemoteAnalytics {...config} />
      </div>
    </Suspense>
  );
}

export default AdmModuleAnalytics;
